export const VoiceConsultationIcon = ({
  customClassName = '',
  onMouseEnter,
  onMouseLeave
}: {
  customClassName?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClassName}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <path
        d="M29.2566 23.0941L25.2975 22.6421C24.3467 22.533 23.4115 22.8603 22.7412 23.5305L19.8732 26.3985C15.4621 24.154 11.8459 20.5534 9.60142 16.1267L12.485 13.2431C13.1552 12.5729 13.4826 11.6376 13.3735 10.6868L12.9214 6.7589C12.7344 5.18461 11.4095 4 9.81964 4H7.1231C5.36179 4 3.89662 5.46518 4.00573 7.22651C4.83183 20.5378 15.4777 31.1682 28.7734 31.9943C30.5347 32.1034 31.9998 30.6382 31.9998 28.8769V26.1803C32.0154 24.606 30.8308 23.2811 29.2566 23.0941Z"
        fill="currentColor"
      />
    </svg>
  )
}
